
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import ChatWidget from "components/ChatWidget/ChatWidget";
import tokenMonitor from "services/tokenMonitor";
import { AuthProvider } from "contexts/AuthContext";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import 'react-toastify/dist/ReactToastify.css';

import UserLayout from "layouts/User.js";
import AdminLayout from "layouts/Admin.js";
import Login from "views/Login";
import Signup from "views/Signup";
import Check from "./Check";
import Tos from "views/Tos";
import PrivacyPolicy from "views/PrivacyPolicy";
import NotFound from "views/NotFound";








const root = ReactDOM.createRoot(document.getElementById("root"));

// start token monitor 
tokenMonitor.start();

root.render(
  <BrowserRouter>
  <AuthProvider>
    <ChatWidget />
  
    <Routes>
      
      <Route path="/user/*" element={<Check> <UserLayout /> </Check>} />
      <Route path="/admin/*" element={<Check> <AdminLayout /> </Check>} />
      {/* <Route path="/" element={<Navigate to="/admin/dashboard" replace />} /> */}
      {/* <Route path="/login" element={<Login />} />
      <Route path="/SignUp" element={<HomeSignup />} /> */}
      
      {/* <Route path="/" element={<NewLogin />} /> */}
      <Route path="/" element={<Login />} />
      {/* <Route path="/signup" element={<Signup />} /> */}
      <Route path="/terms-of-service" element={<Tos />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      
      
      {/* Catch-all 404 */}
        <Route path="*" element={<NotFound/>} />
    </Routes>
    </AuthProvider>
  </BrowserRouter>
);
